import request from '@/utils/request'

const url = 'village'
const url2 = 'pm/village'

/** 获取小区下拉框 */
export function searchVillageSelectList(data) {
  return request({
    url: `${url}/searchVillageSelectList`,
    method: 'post',
    data
  })
}

/** 获取小区列表 */
export function searchVillageList(data) {
  return request({
    url: `${url}/searchVillageList`,
    method: 'post',
    data
  })
}

/** 获取小区列表 */
export function searchVillageListPm(data) {
  return request({
    url: `${url2}/searchVillageList`,
    method: 'post',
    data
  })
}

/** 查看小区 */
export function getVillageInfo(data) {
  return request({
    url: `${url}/getVillageInfo`,
    method: 'post',
    data
  })
}

/** 添加小区 */
export function insertVillageInfo(data) {
  return request({
    url: `${url}/insertVillageInfo`,
    method: 'post',
    data
  })
}

/** 编辑小区 */
export function editVillageInfo(data) {
  return request({
    url: `${url}/editVillageInfo`,
    method: 'post',
    data
  })
}

/** 删除小区 */
export function deleteVillageInfo(data) {
  return request({
    url: `${url}/deleteVillageInfo`,
    method: 'post',
    data
  })
}

export function searchAllVillage() {
  return request({
    url: `${url}/searchAllVillage`,
    method: 'post',
  })
}

export function getVillageCount(data) {
  return request({
    url: `${url2}/getVillageCount`,
    method: 'post',
    data
  })
}

export function clearVillageAllInfo(data) {
  return request({
    url: `${url2}/clearVillageAllInfo?vVillageId=${data.vVillageId}`,
    method: 'post',
    data
  })
}

export function addElevator(data) {
  return request({
    url: `${url2}/addElevator`,
    method: 'post',
    data
  })
}

export function delElevator(data) {
  return request({
    url: `${url2}/delElevator`,
    method: 'post',
    data
  })
}

export function batchAddElevator(data) {
  return request({
    url: `${url2}/batchAddElevator`,
    method: 'post',
    data
  })
}